import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('please_change_my_email_to'),
    subtitle: defineMessage('please_doublecheck_your_new_email_address'),
    description: defineMessage('make_sure_the_email_you_important_notifications'),
    buttonSend: defineMessage('send'),
    fieldEmailLabel: defineMessage('new_email'),
    fieldEmailPlaceholder: defineMessage('enter_new_email'),
};
